import { render, staticRenderFns } from "./lab-product-detail.vue?vue&type=template&id=d51328aa"
import script from "./lab-product-detail.vue?vue&type=script&lang=js"
export * from "./lab-product-detail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports